import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'irembogov-portal-footer',
  templateUrl: './portal-footer.component.html',
  styleUrls: ['./portal-footer.component.scss'],
  imports: [TranslateModule],
})
export class PortalFooterComponent {
  currentYear = new Date().getFullYear();
  env = environment;
}
